import { IRootState } from '..';

export const SELECTOR_STATS_STATS = (state: IRootState) => state.Stats.stats;
export const SELECTOR_STATS_EVENTS = (state: IRootState) => state.Stats.events;
export const SELECTOR_STATS_SHOW_STATS = (state: IRootState) => state.Stats.showStats;
